import { motion } from 'framer-motion';
import { Diamond } from 'lucide-react';
import { getLeagueConfig } from './league-tokens';

export function LeagueXpBar({ liga, nextLeagueId, seasonXp = 0, maxLeagueXp = 1 }) {
  const cfg = getLeagueConfig(liga);
  const nextCfg = nextLeagueId ? getLeagueConfig(nextLeagueId) : null;
  const fraction = Math.max(0, Math.min(1, maxLeagueXp ? seasonXp / maxLeagueXp : 0));

  return (
    <div className="flex items-center gap-3 sm:gap-4">
      <span className="text-xs font-bold tabular-nums text-slate-700 sm:text-sm">
        {seasonXp.toLocaleString()} XP
      </span>

      <div className="relative h-3 flex-1 overflow-hidden rounded-full bg-slate-200">
        <motion.div
          className="absolute inset-y-0 left-0 rounded-full"
          style={{
            background: `linear-gradient(90deg, ${cfg.accent}, ${nextCfg?.accent || cfg.accent})`,
            boxShadow: `0 0 12px ${cfg.accent}88`,
          }}
          initial={{ width: 0 }}
          animate={{ width: `${fraction * 100}%` }}
          transition={{ duration: 0.9, ease: 'easeOut', delay: 0.15 }}
        />
      </div>

      <div className="flex items-center gap-1.5">
        <span className="text-xs font-bold tabular-nums text-slate-500 sm:text-sm">
          {maxLeagueXp.toLocaleString()}
        </span>
        <motion.div
          initial={{ scale: 0.6, rotate: -20, opacity: 0 }}
          animate={{ scale: 1, rotate: 0, opacity: 1 }}
          transition={{ type: 'spring', stiffness: 220, damping: 14, delay: 0.4 }}
          style={{
            color: nextCfg?.accent || cfg.accent,
            filter: `drop-shadow(0 0 8px ${(nextCfg?.accent || cfg.accent) + '66'})`,
          }}
        >
          <Diamond className="h-5 w-5 fill-current" />
        </motion.div>
      </div>
    </div>
  );
}

export default LeagueXpBar;
